export const MAX_DOCUMENT_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_DOCUMENT_SIZE_LABEL = "10 Mo";
export const DOCUMENT_ACCEPT_ATTRIBUTE =
  ".jpg,.jpeg,.png,.webp,.pdf,image/jpeg,image/png,image/webp,application/pdf";

const ALLOWED_DOCUMENT_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/webp",
  "application/pdf",
]);

export const isPdfDocument = (document) => {
  const candidate =
    typeof document === "string"
      ? document
      : `${document?.type || ""} ${document?.format || ""} ${
          document?.name || document?.path || document?.filePath || ""
        }`;

  return /application\/pdf|\bpdf\b|\.pdf(?:$|[?#])/i.test(candidate);
};
export const validateDocumentFile = (file) => {
  if (!file) return "Sélectionnez un fichier à importer.";

  const hasAllowedExtension = /\.(?:jpe?g|png|webp|pdf)$/i.test(file.name || "");
  if (!ALLOWED_DOCUMENT_TYPES.has(file.type) && !hasAllowedExtension) {
    return "Format non accepté. Utilisez une image JPG, PNG ou WEBP, ou un document PDF.";
  }

  if (file.size > MAX_DOCUMENT_SIZE_BYTES) {
    return `Ce fichier dépasse la taille maximale autorisée de ${MAX_DOCUMENT_SIZE_LABEL}.`;
  }

  return null;
};

export const getUploadErrorMessage = (error) => {
  const status = error?.response?.status;
  const serverMessage =
    error?.response?.data?.error || error?.response?.data?.message || "";

  if (
    status === 413 ||
    /taille|size limit|too large|volumineux/i.test(serverMessage)
  ) {
    return `Le fichier est trop volumineux. La taille maximale autorisée est de ${MAX_DOCUMENT_SIZE_LABEL}.`;
  }

  if (
    status === 415 ||
    (status === 400 &&
      /format|type|extension|invalid attachment|not authorized|non autoris/i.test(
        serverMessage,
      ))
  ) {
    return "Format non autorisé. Formats acceptés : JPG, JPEG, PNG, GIF, WEBP, MP4, M4V, WEBM, MOV et PDF.";
  }

  if (
    error?.code === "ERR_NETWORK" ||
    error?.message === "Network Error" ||
    !error?.response
  ) {
    return "Erreur réseau : le fichier n'a pas pu être transmis au serveur. Vérifiez votre connexion puis réessayez.";
  }

  return (
    serverMessage ||
    "L’importation n’a pas pu aboutir. Vérifiez le format du fichier, puis réessayez."
  );
};
